// ============================================================
// iCON Finanças Inteligentes — TODO O CONTEÚDO DO SITE
// Edite os textos abaixo para atualizar a página.
// ============================================================

// ------------------------------------------------------------
// CONFIGURAÇÃO DE CONTATO — EDITE AQUI
// ------------------------------------------------------------
// WHATSAPP_NUMERO: somente dígitos, no formato 55 + DDD + número.
//   Exemplo de formato: "5511999999999" (não é um número real).
// Enquanto o valor abaixo não for substituído, os botões abrem o
// WhatsApp para o visitante escolher o contato (sem número fixo).
export const WHATSAPP_NUMERO = "556730471381"; // (67) 3047-1381

export const contato = {
  whatsappNumero: WHATSAPP_NUMERO,
  telefoneExibicao: "(67) 3047-1381",
  whatsappMensagem: "Olá! Vim pelo site da iCON e gostaria de falar com um especialista.",
  // Troque pela cidade/região de atendimento presencial
  cidade: "Campo Grande/MS",
  // Endereço do escritório (aparece no mapa da seção de contato e no rodapé)
  endereco: "Avenida Afonso Pena, 5723, Sala 1504",
  // Troque pelo e-mail real (vira link automaticamente quando for um e-mail válido)
  email: "icon@iconfinancas.com",
};

export const whatsappConfigurado = /^\d{12,13}$/.test(contato.whatsappNumero);

export const whatsappLink = (msg = contato.whatsappMensagem) =>
  whatsappConfigurado
    ? `https://wa.me/${contato.whatsappNumero}?text=${encodeURIComponent(msg)}`
    : `https://wa.me/?text=${encodeURIComponent(msg)}`;

export const emailValido = /^[^\s@\[\]]+@[^\s@\[\]]+\.[^\s@\[\]]+$/.test(contato.email);

export const marca = {
  // LOGO: coloque o arquivo em frontend/public (ex.: logo-icon.png) e
  // preencha abaixo com "/logo-icon.png". Vazio = logo em texto.
  logoUrl: "/logo-icon-mark.png",
  // Logo completo (com "Finanças Inteligentes"): "/logo-icon.png"
  nome: "iCON",
  complemento: "Finanças Inteligentes",
};

export const nav = {
  links: [
    { label: "Soluções", href: "#solucoes" },
    { label: "Sobre", href: "#sobre" },
    { label: "Metodologia", href: "#metodologia" },
    { label: "Contato", href: "#contato" },
  ],
  cta: "Fale com um especialista",
};

export const hero = {
  selo: "Gestão financeira para pequenas e médias empresas",
  titulo: "Transforme seus números em decisões inteligentes.",
  destaque: "decisões inteligentes.",
  subtitulo:
    "Inteligência financeira para empresas que buscam mais controle, rentabilidade e crescimento sustentável.",
  botaoPrimario: "Fale com um especialista",
  botaoSecundario: "Conheça nossas soluções",
  atendimento: `Atendimento presencial em ${contato.cidade} e online para todo o Brasil`,
};

// Painel ilustrativo do hero (valores apenas visuais, não são resultados reais)
export const painel = {
  titulo: "Painel financeiro",
  legenda: "Visualização ilustrativa",
  metricas: [
    { label: "Receita", tendencia: "up" },
    { label: "Margem", tendencia: "up" },
    { label: "Caixa", tendencia: "up" },
  ],
  indicadores: ["Liquidez", "Endividamento", "Ponto de equilíbrio"],
};

export const servicos = {
  overline: "Nossas soluções",
  titulo: "Tudo o que a gestão financeira da sua empresa precisa.",
  descricao:
    "Da rotina operacional às decisões estratégicas, a iCON estrutura as finanças do seu negócio com clareza e método.",
  // Botão de cada cartão: abre o WhatsApp já citando o serviço
  botaoCard: "Falar sobre este serviço",
  mensagemServico: (servico) =>
    `Olá! Vim pelo site da iCON e tenho interesse no serviço de ${servico}. Gostaria de falar com um especialista.`,
  itens: [
    {
      id: "consultoria",
      icone: "Compass",
      titulo: "Consultoria Financeira",
      texto:
        "Diagnóstico completo e acompanhamento estratégico para identificar gargalos, priorizar ações e apoiar as decisões que definem o crescimento e a rentabilidade da empresa.",
      destaques: ["Diagnóstico financeiro", "Plano de ação", "Apoio à decisão"],
    },
    {
      id: "bpo",
      icone: "Layers",
      titulo: "BPO Financeiro",
      texto:
        "Assumimos a rotina financeira da sua empresa — contas a pagar e a receber, conciliação bancária e fechamento mensal — para que você tenha controle do caixa todos os dias e tempo para focar no negócio.",
      destaques: ["Controle diário do caixa", "Conciliação bancária", "Fechamento mensal"],
    },
    {
      id: "dre",
      icone: "FileBarChart",
      titulo: "DRE Gerencial",
      texto:
        "Resultados apresentados de forma clara para a gestão: saiba quanto sua empresa realmente lucra, quais custos pesam na margem e onde estão as oportunidades de rentabilidade.",
      destaques: ["Lucro real", "Análise de margem", "Custos e despesas"],
    },
    {
      id: "fluxo",
      icone: "Activity",
      titulo: "Fluxo de Caixa e Indicadores",
      texto:
        "Controle e projeção do fluxo de caixa com indicadores financeiros acompanhados periodicamente — liquidez, capital de giro, endividamento e ponto de equilíbrio — para antecipar necessidades e evitar surpresas.",
      destaques: ["Projeção de caixa", "Capital de giro", "Indicadores-chave"],
    },
    {
      id: "precificacao",
      icone: "Tags",
      titulo: "Precificação",
      texto:
        "Preços formados a partir dos custos reais, despesas, impostos e margem desejada, para vender com segurança e proteger a rentabilidade de cada produto ou serviço.",
      destaques: ["Custos reais", "Margem de contribuição", "Preço de venda"],
    },
    {
      id: "valuation",
      icone: "Gem",
      titulo: "Valuation",
      texto:
        "Avaliação técnica do valor da empresa para apoiar decisões estratégicas: negociações, entrada ou saída de sócios, captação de recursos, fusões ou planejamento sucessório.",
      destaques: ["Valor da empresa", "Negociações e sócios", "Decisões estratégicas"],
    },
  ],
};

export const sobre = {
  overline: "Sobre a iCON",
  titulo: "Finanças com inteligência, clareza e propósito.",
  paragrafos: [
    "A iCON Finanças Inteligentes é uma consultoria de gestão financeira dedicada a pequenas e médias empresas que querem crescer com controle.",
    "Transformamos dados financeiros dispersos em informação organizada e acionável, para que empresários tomem decisões com segurança — e não por intuição.",
  ],
  pilares: [
    { titulo: "Controle", texto: "Rotinas e processos financeiros organizados." },
    { titulo: "Rentabilidade", texto: "Foco em margem, custos e resultado." },
    { titulo: "Crescimento sustentável", texto: "Decisões estratégicas apoiadas em dados." },
  ],
};

export const metodologia = {
  overline: "Metodologia",
  titulo: "Um método claro, do diagnóstico à decisão.",
  descricao: "Cada projeto segue etapas definidas para gerar visibilidade e resultados consistentes.",
  etapas: [
    {
      numero: "01",
      titulo: "Diagnóstico",
      texto: "Entendemos o negócio, mapeamos processos e levantamos a situação financeira atual.",
    },
    {
      numero: "02",
      titulo: "Estruturação",
      texto: "Organizamos plano de contas, rotinas, controles e a base de dados financeira.",
    },
    {
      numero: "03",
      titulo: "Análise",
      texto: "Construímos DRE gerencial, fluxo de caixa e indicadores para leitura clara dos números.",
    },
    {
      numero: "04",
      titulo: "Decisão e acompanhamento",
      texto: "Apresentamos recomendações e acompanhamos a evolução de forma contínua.",
    },
  ],
};

export const ctaFinal = {
  overline: "Vamos conversar",
  titulo: "Pronto para tomar decisões com base em números?",
  texto:
    "Converse com um especialista da iCON e descubra como estruturar a gestão financeira da sua empresa.",
  botao: "Falar no WhatsApp",
  atendimento: `Presencial em ${contato.cidade} · Online para todo o Brasil`,
};

export const mapa = {
  titulo: "Onde estamos",
  botao: "Abrir no Google Maps",
  // Texto usado no botão "Abrir no Google Maps"
  consulta: "Evolution Business Center, Avenida Afonso Pena, 5723, Campo Grande - MS, 79031-010",
  // Posição exata do alfinete no mapa (latitude,longitude do Edifício Evolution Business Center)
  coordenadas: "-20.457821,-54.582489",
};

export const rodape = {
  descricao: "Consultoria de gestão financeira para pequenas e médias empresas.",
  direitos: "Todos os direitos reservados.",
};
